import { Link } from "react-router-dom";
import { scrollToTop } from "../../utilities.js";

import { ReactComponent as InstaIcon } from "../../img/icon/instagram.svg";
import { ReactComponent as MailIcon } from "../../img/icon/envelop.svg";
import { ReactComponent as GlobeIcon } from "../../img/icon/link.svg";
import { ReactComponent as FacebookIcon } from "../../img/icon/facebook.svg";

import "../../utilities.css";
import "./SocietyBasicInfo.css";

/**
 * Profile Left is a component in profile displaying personal detail
 * of a user.
 *
 * Proptypes
 * @param societyObj for user object
 */

const SocietyBasicInfo = ( {societyObj} ) => {
  return (
    <div className="societybasicinfo-basic">
      <p>Also known as <br/> <b>{societyObj.shortName}</b></p>
      <p>Nature 
        <br/> 
        <span className="societybasicinfo-nature" 
              style={{
              backgroundColor: societyObj.societyNature.bkgColor,
              color: societyObj.societyNature.textColor,
              }}
              > 
          {societyObj.societyNature.name}
        </span>
      </p>

      {societyObj.president && 
        <p>
          President
          <br/>
          {societyObj.president.display 
            ? 
              <Link to={`/profile/${societyObj.president.username}`} onClick={scrollToTop}><b>{societyObj.president.preferredName}</b></Link>
            : 
            <>{societyObj.president.email 
              ? 
              <a href={`mailto:${societyObj.president.email}`}><b>{societyObj.president.preferredName}</b></a>
              :
              <b>{societyObj.president.preferredName}</b>
            }</>
          }
        </p>
      }

      {societyObj.wcr_contact.length !== 0 && 
        <p>WCR Contacts <br/>
          {societyObj.wcr_contact.map((item) => {
            if (item.display) {
              return (
                <b key={item.key} className="societybasicinfo-wcrcontact">
                  <Link to={`/profile/${item.username}`}>{item.preferredName}</Link>
                </b>)
            } else if (item.email) {
              return (
                <b key={item.key} className="societybasicinfo-wcrcontact">
                  <a href={`mailto:${item.email}`}>{item.preferredName}</a>
                </b>)
            } else
            return (
              <b key={item.key} className="societybasicinfo-wcrcontact">
                {item.preferredName}
              </b>)
          })}
        </p>
      }

      <p>
        {societyObj.email && (
          <>
            <a href={`mailto:${societyObj.email}`}> 
              <MailIcon />
            </a>
          </>)}
        {societyObj.websiteLink && (
          <>
            <a href={societyObj.websiteLink}>
              <GlobeIcon /> 
            </a>
          </>)}
        {societyObj.facebookLink && (
          <>
            <a href={societyObj.facebookLink}>
              <FacebookIcon />
            </a>
          </>)}
        {societyObj.instagramLink && (
          <>
            <a href={societyObj.instagramLink}>
              <InstaIcon />
            </a>
          </>)}
      </p>
    </div>
  );
};

export default SocietyBasicInfo;